// REQUIRED IMPORTS
const $ = require('jquery');
import _ from "underscore";
import run from '../../utilities/run';
import render from "../../utilities/render";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import addressValidationFactory from '../common/AddressValidation.js';
import { handleDisplayFor, setElementsFromScope } from "../../utilities/selectorHelpers";
import { createPreventDefault } from '../../utilities/general';
import { instantiateSelect2 } from "../../utilities/select2able";
import EditChecker from '../../components/EditChecker/EditChecker';
import { setSwitchery, instantiateSwitchery } from "../../utilities/instantiateSwitchery";
// Additional Imports...

const facilityWrapperTemplate = require('./html/createOrganization/vmoFormFacilityFormWrapper.html');
const facilityTypeHtml = require('./html/createOrganization/vmoFacilityType.html');
const inboundClassificationHtml = require('./html/createOrganization/vmoInboundClassification.html');
const facilityDetailsHtml = require('./html/createOrganization/vmoFacilityDetails.html');
const facilityAddressHtml = require('./html/createOrganization/vmoFacilityAddress.html');
const facilityContactHtml = require('./html/createOrganization/vmoFacilityContact.html');
const sharedModalHtml = require("../../sharedHtml/modal.html");


const targetSelector = "#facility-form";

run(targetSelector, (mainEl) => {
  attachOrgForm(mainEl);
});

function attachOrgForm(mainEl) {
  const editForm = mainEl.data("edit-form");
  const portletNamespace = mainEl.data('portlet-namespace');
  let organizations = mainEl.data('organizations');
  const isHoneyComb = mainEl.data('is-honeycomb');
  const countries = mainEl.data('countries');
  const usaStates = mainEl.data('usa-states');
  const caProvinces = mainEl.data('ca-provinces');
  const phoneCodes = mainEl.data('country-phone-code-list');
  const defaultCountry = mainEl.data('default-country');
  const facilityTypes = mainEl.data('facility-types');
  const inboundClassificationTypes = mainEl.data('inbound-classification-types');
  const retailerFedexAccounts = mainEl.data('retailer-fedex-accounts');
  const retailerFacilityForRMS = mainEl.data('retailer-facility-for-rms');
  const addressEl = $('#edit-address-verification');
  const validateOrgNameUrl = mainEl.data("validate-org-url");
  const addressValidationUrl = mainEl.data("address-validation-url");
  const organizationList = mainEl.data("retailer-organization-list");
  const submitURL = mainEl.data("submit-url");
  const detailScreenUrl = mainEl.data("detail-url");
  const cancelBtnUrl = mainEl.data("cancel-url");
  const facNameCheckUrl = mainEl.data("fac-name-check-url")
  const facIdCheckUrl = mainEl.data("fac-id-check-url");
  const duplicateCadLocationNameMessage = mainEl.data("duplicate-location-name-message");
  const duplicateAddressIdMessage = mainEl.data("duplicate-address-id-message");
  const casAccountNumbers = mainEl.data("cas-acccount-numbers");
  const shipToAddress = mainEl.data("ship-to-address"); //HB-11508 Starts, Ends.
  const validationReqdCountries = mainEl.data("validation-reqd-countries");
  let organizationSelectionCheck="";
  let facilityCount = 0;
  let facilityArray = [];
  const orgFacilityForm = $('#org-facility-form');
  let orgName = "";
  let facName = "";
  let facId = "";
  let cadEditId="";
  let conPhoneCode="";
  //Variable to store the response from the address validation service 
  let addValResponse = {};

  let selectFromOrgModal;

  let elsPage = {};
  //let elsModal = {};
  

  const elsMap = {
    addFacilitySection: ".add-facility-section",
    organizationName: "#org-address-name",
    addFirstFacilityBtn: ".first-add-facility-btn",
    saveVendorOrgAddressBtn: ".save-vendor-org-address-btn",
    masterFormCancelBtn: ".master-facility-cancel-section-btn",
    facilityEditSectionBtn: ".facility-edit-section-btn",
    facilityUpdateSectionBtn: ".facility-update-section-btn",
    facilityCancelSectionBtn: ".facility-cancel-section-btn",
    masterFormSectionParent: ".master-form",
    customExpanderParent: ".custom-expander-parent",
    customExpanderTarget: ".custom-expander-target",
    staticFacilityFormDiv: ".facility-information-container",
    selectOrgName: "#selectOrgName",
    orgName: "#selectOrgName",
    inboundClassification: "#inboundClassification",
    facilityType: "#rms-facility-type",
    cancelBtn: ".cancel-url"
  }

  /*const elsModalMap = {
    orgnSelectBtn: '.organization-select-btn',
    dropDownOption :"#organizationDropdown"
  }*/


  const addressElementsMap = {
    submitThisAddressBtn: '#submit-edit-returned-address',
    addressEntered: '#div-address-enetered',
    enteredAddressRadio: '#radio-use-entered-address',
    enteredAddressText: '#edit-ret-address-entered',
    addressReturned: '#div-address-returned',
    returnedAddressRadio: '#radio-returned-address',
    returnedAddressText: '#edit-ret-address-returned',
    invalidAddress: '#div-address-returned-empty',
    invalidAddressText: '#edit-ret-address-returned-not-found',
    modifyAddressBtn: '#modify-edit-returned-address'
  }

  function init() {
    setElements();
    //setElementsOnModal();
    bindElements();
    if (editForm) {
      populateEditForm(organizations);
    }
    else{
      showStaticForm();
    }   
    renderOrganizationValues();
    $("#errorMessageForCheckbox").hide();
    $('.facilityType').click(function(){
      $("#errorMessageForCheckbox").hide();
    });
    setupEditChecker();
  }

  function setElements() {
    //Tie the scope of the elements on the page 
    setElementsFromScope(elsPage, elsMap, orgFacilityForm);
    setElementsFromScope(elsPage, addressElementsMap, addressEl);
  }

  /*function setElementsOnModal(){
    // since modals are appended to the body, they are scopped differnetly
    const body = $('body');
    setElementsFromScope(elsModal, elsModalMap, body);
  }*/

  function setupEditChecker() {
    EditChecker.bindNavigation();
    EditChecker.bindChangeListener("#facility-form");
    EditChecker.bindChangeListener("span.select2");
    //EditChecker.bindCancelButton("#cancel-vendor-org-address-btn");
    EditChecker.bindCancelButton(".cancel-url");
  }

  function bindElements() {
    //Bind the events of the Button here 
    elsPage.modifyAddressBtn.on('click', modifyFacilityAddress);
    elsPage.submitThisAddressBtn.on('click', submitFacilityAddress);
    elsPage.saveVendorOrgAddressBtn.on('click', orgSaveBtnHandler);
    mainEl.on("blur",".facility-name",validateFacilityName);
    mainEl.on("blur",".facility-id",validateFacilityId);
    mainEl.on("change",".facility-phone-code", phoneCodeChange);
 
  }

  function orgSaveBtnHandler() {
    const orgFormEle = mainEl.find("#master-form");
    const isValidOrgForm = validateForm(orgFormEle);
    if (isValidOrgForm) {
      if (isHoneyComb) {
        let checked = $("#org-facility-form input:checkbox:checked").length > 0;
        if (!checked) {
          $("#errorMessageForCheckbox").show();
          return false;
        }
        $("#errorMessageForCheckbox").hide();
      }
      validateAddressModal();
    }
  }
//duplicate facility name check
  function validateFacilityName() {
    const facName = mainEl.find(".facility-name").val();
    const localFacName= organizations.cadLocationName;
     if(localFacName!=facName ){
      $.ajax({
        async: false,
        data: {
            facName:facName,
        },
        url: facNameCheckUrl,
        dataType:"JSON",
        type: 'POST',
        success: function(data){
          //isFacNameDuplicate = data.response;
          if(data.response== true) {
            mainEl.find('.dup-facName').show();  
          }else{
            mainEl.find('.dup-facName').hide();
          }  
        }  
     });
    } else{
      mainEl.find('.dup-facName').hide();
    }
  }

  function validateFacilityId() {
    const facId =   mainEl.find(".facility-id").val();
    const localFacId= organizations.cadAddressId;
    if(localFacId!=facId){
      $.ajax({
        async: false,
        data: {
          facId:facId,
        },
        url: facIdCheckUrl,
        dataType:"JSON",
        type: 'POST',
        success: function(data){
          //isFacIdDuplicate = data.response;
          if(data.response== true) {
            mainEl.find('.dup-facId').show();
          }else{
            mainEl.find('.dup-facId').hide();
          }  
        }  
     });
    }else{
      mainEl.find('.dup-facId').hide();
    }

  }


  function saveFacility() {
    const submitModalFlow = new SubmitModalFlow({
      confirmModalTitle: "Save Facility",
      confirmModalBody: '<div class="q-pad-all-xl">Once you have saved this Facility, it can be referenced throughout the application.</div>',
      confirmModalBtnText: "Save",
      onConfirmClick: function () {
        let orgFlagCheck =true;
        for(let i=0;i<organizationList.length;i++){
          if(organizationList[i].orgId == elsPage.orgName.val() && organizationList[i].orgActive == false && organizations.cadActive === "Y")
          {
             submitModalFlow.hideAllModals();
             saveInActiveOrg();
             orgFlagCheck =false;
          }else if(organizationList[i].orgId == elsPage.orgName.val() && organizationList[i].orgActive == false && !editForm){
             submitModalFlow.hideAllModals(); 
             saveInActiveOrg();
             orgFlagCheck =false;
          }else if(organizationList[i].orgId == elsPage.orgName.val() && organizationList[i].orgActive == false && organizations.cadActive === "N" && organizationSelectionCheck!=elsPage.orgName.val()){
             submitModalFlow.hideAllModals(); 
             saveInActiveOrg();
             orgFlagCheck =false;
          }
        }
        if(orgFlagCheck){
        let orgId = elsPage.orgName.val() || '';
        let saveOrgFacURL = submitURL + "&orgId=" + orgId;      
        submitModalFlow.showLoadingModal();
        submitOrg({ url: saveOrgFacURL, success: saveOrgSuccess, error: saveOrgFailure });
        function submitOrg({ url, success, error }) {
            $.ajax({
            data: {
              facilityArray:JSON.stringify(facilityArray)
            },
            url: url,
            dataType: "JSON",
            type: 'POST',
            success: success,
            error: error
          });
        }
      }
        function saveOrgSuccess(data) {
          EditChecker.setPageClean();
          submitModalFlow.hideAllModals();
          submitModalFlow.showSuccessModal();
          setTimeout(function () {
          window.open(detailScreenUrl + "&cadId=" + data, "_self");
          }, 3000);
        }
        function saveOrgFailure() {
         //submitModalFlow.hide();
         submitModalFlow.hideAllModals();
         
        }
      }
    });
    submitModalFlow.init();
    submitModalFlow.showConfirmModal();
  }

  function saveInActiveOrg() {
    
    const submitModalFlow = new SubmitModalFlow({
      confirmModalTitle: "Save Facility",
      confirmModalBody: '<div class="q-alert q-marg-all-xl q-alert-red"> The organization assigned to this facility is currently in an inactive status.</div><div class="q-marg-all-xl">Once saved, this facility will present and maintain an inactive status until it\'s assigned organization is active.</div>',
      confirmModalBtnText: "Save",
      onConfirmClick: function () {
        let orgId = elsPage.orgName.val() || '';
        let saveOrgFacURL = submitURL + "&orgId=" + orgId;
        submitModalFlow.showLoadingModal();
        submitOrg({ url: saveOrgFacURL, success: saveOrgSuccess, error: saveOrgFailure });
        function submitOrg({ url, success, error }) {
            $.ajax({
            data: {
              facilityArray:JSON.stringify(facilityArray)
            },
            url: url,
            dataType: "JSON",
            type: 'POST',
            success: success,
            error: error
          });
        }
        function saveOrgSuccess(data) {
          EditChecker.setPageClean();
          submitModalFlow.hideAllModals();
          submitModalFlow.showSuccessModal();
          setTimeout(function () {
          window.open(detailScreenUrl + "&cadId=" + data, "_self");
          }, 3000);
        }
        function saveOrgFailure() {
         //submitModalFlow.hide();
         submitModalFlow.hideAllModals();
         
        }
      }
    });
    submitModalFlow.init();
    submitModalFlow.showConfirmModal();
  }

  function renderOrganizationValues() {
    let orgIdToBeSelected="";
    for(let i=0;i<organizationList.length;i++){
      if(organizationList[i].orgName === organizations.cadOrganizationName ){
        orgIdToBeSelected=organizationList[i].orgId;
      }
    }

    let returnTypeList = "";
    returnTypeList = organizationList.map((el) => {
      return render("<option value = '{%-key %}'>{%-value %}</option>", {
        key: el.orgId,
        value: el.orgName
      });
    });

    elsPage.selectOrgName.append(returnTypeList);
    elsPage.selectOrgName.val(orgIdToBeSelected);
    organizationSelectionCheck=orgIdToBeSelected;
    elsPage.selectOrgName.trigger('change');
  }

  function getRmsFacilityTypes(){
    if(!isHoneyComb){
      return render(require("./html/createOrganization/rmsFacilityTypes.html"),{
        rmsFacilityTypes: getRenderedRmsFacility(retailerFacilityForRMS),
        rmsFedexAccounts: getRenderedFedexAccounts(retailerFedexAccounts),
        rmsCasAccountDetails : renderCasAccount(),
        shipToAddress: getRenderedShipToAddress(shipToAddress)
      });
    }
  }

  function renderCasAccount(){
    if(casAccountNumbers.length>0){
      return render(require("./html/createOrganization/rmsCasAccount.html"),{
      rmsCasAccountDetails : getRenderedCasAccounts(casAccountNumbers)
      });
    }
  }

  function getHcmbFacilityTypes(cmrAddressObj) {
    if (isHoneyComb) {
      return render(facilityTypeHtml, {
        ...cmrAddressObj,
        facilityTypes: getRenderedFacilityTypes(facilityTypes)
      });
    }
  }

  function getHcmbFacilityTypesEdit(cmrAddressObj) {
    if (isHoneyComb) {
      return render(facilityTypeHtml, {
        ...cmrAddressObj,
        facilityTypes: getRenderedFacilityTypesEdit(facilityTypes,cmrAddressObj.cmrAddressAttributes)
      });
    }
  }

  function showStaticForm() {
    organizations.orgName = "elsPage.organizationName.val()";
    const orgNewFormHtml = $(render(facilityWrapperTemplate,
      {
        masterForm: true,
        facilityDetails: render(facilityDetailsHtml, {
          rmsFacilityTypes:getRmsFacilityTypes(),
          dupFacName:duplicateCadLocationNameMessage,
          dupFacId: duplicateAddressIdMessage
        }),
        facilityType: getHcmbFacilityTypes(),
        inboundClassification: getRMSTypes(),
        facilityAddress: render(facilityAddressHtml, {
          countries: getRenderedCountries(countries)
        }),
        facilityContact: render(facilityContactHtml, {
          phoneCodes: getRenderedPhoneCodes(phoneCodes)
        }),
        facilityName: "Facility Details",
        sectionIsExpandable: false,
        isHoneyComb
      }
    ));

    elsPage.staticFacilityFormDiv.append(orgNewFormHtml);
    $('.vendorSelectAuthorization').hide();
    $('#inboundClassification').hide();
    $('.ship-to-address-row').hide();

    ///Trigger on the default values
    instantiateSelect2(orgNewFormHtml.find('.select2-select'));

    //Handle the change events in the form 
    orgNewFormHtml.find(".facility-country").on("change", handleCountryChange);
    $('#rms-facility-type').on('change', showInboundClassification);
    orgNewFormHtml.find(".facility-country").val(defaultCountry).trigger('change');
    orgNewFormHtml.find(".facility-phone-code").val("+1").trigger('change');
    orgNewFormHtml.find('.phone-number').inputmask({
      mask: "(999) 999-9999"
    });
  }

  function getRMSTypes(){
    if(!isHoneyComb){
      return render(inboundClassificationHtml, {
        inboundClassificationTypes: getRenderedInboundTypes(inboundClassificationTypes),
      });
    }
  }

  function getRMSTypesEdit(cmrAddressObj){
    if(!isHoneyComb){
      return render(inboundClassificationHtml, {
        ...cmrAddressObj,
        inboundClassificationTypes: getRenderedInboundTypesEdit(inboundClassificationTypes, cmrAddressObj.cmrAddressAttributes),
      });
    }
  }

  function showInboundClassification() {
    if ($("#rms-facility-type").val() == "vendor") {
      $('.vendorSelectAuthorization').show();
	  $('#stndRaLabel').show();
	  $('#stndNumber').show();
      $('#inboundClassification').hide();
      $('.ship-to-address-row').hide();
    }
    else {
		if($("#rms-facility-type").val() == "return"){
			$('.vendorSelectAuthorization').show();
			$('#stndRaLabel').hide();
			$('#stndNumber').hide();
		}
	  //Updated below line by Dhans for Story B-1237968-Enable Return Authorization for Return Center flow in Facilities
      $('.vendorSelectAuthorization').show();
      $('#inboundClassification').show();
      if ($("#rms-facility-type").val() == "inbound") {
		//Added below line by Dhans for Story B-1237968-Enable Return Authorization for Return Center flow in Facilities  
		$('.vendorSelectAuthorization').hide();
        $('.ship-to-address-row').show();
      }else{
        $('.ship-to-address-row').hide();
      }
    }
  }

  function handleCountryChange() {
    handleSwitchingStateInput();
  }

  function setMasks() {
    let phoneCode=$('.phone-number');
    phoneCode.addClass("phoneUS");
    phoneCode.removeClass("phoneNonUS");    
    phoneCode.attr("placeholder", "(___) ___-____");
    phoneCode.inputmask({
      mask: "(999) 999-9999"
    });
  }
  
  function setUnMasks() {
    let phoneCode=$('.phone-number');
    phoneCode.addClass("phoneNonUS");
    phoneCode.removeClass("phoneUS");
    phoneCode.attr("placeholder", "");
    phoneCode.inputmask({
      mask: ""
    }); 

    let val= phoneCode.val();						
    if(val){
      let v=   val.replace(/[- )(]/g,'');
      v=v.replace(/[^0-9.]/g, "");
      phoneCode.val(v);
    }
  
  }

  function phoneCodeChange(){
    let phonecode= mainEl.find(".facility-phone-code").val().toString();
    if( phonecode === '+1'){
      setMasks();
    }else{
      setUnMasks();     
    } 
  }

  function handleSwitchingStateInput() {
    let countryVal = $('.facility-country  :selected').val();
    let isValidCountry =false;
    let countryValue='';
    let checkZipCode = false;
    $(countries).each(function() {
      if(this.conId.toString() === countryVal.toString()) {
        conPhoneCode = this.conPhoneCode.toString();
        countryValue = this.conCode;
        if(this.conPostalCodeRequired.toString() === "Y"){
          checkZipCode=true;
        }
        return false;
      } 
    });
    $(phoneCodes).each(function(){
      if(this.conPhoneCode === conPhoneCode){
        mainEl.find(".facility-phone-code").find('option[value="'+this.conPhoneCode+'"]').prop('selected', 'selected').trigger('change');
        return false;
      }
    });

    if (countryVal == "1" || countryVal == "2"){
      $(".facility-stateText-wrapper").hide();
      $(".facility-state-wrapper").show();
      $(".state-label").text("State/Province/Region *")
      getRenderedStatesorProvince(countryVal);
    }
    else {
      $(".facility-stateText-wrapper").show();
      $(".facility-state-wrapper").hide();
      $(".state-label").text("State/Province/Region")

    }
    $(validationReqdCountries).each(function() {
      if(this.cdmValue.toString() === countryValue.toString()) {
        isValidCountry = true;
        return false;
      } 
    });
    if(isValidCountry){
      $(".country-not-supported-primary").hide();        
    }else{
      $(".country-not-supported-primary").show();
    }
    const postalCode = $("#facility-zip");
    const postalCodeLabel = $(".facility-zip-label");
    if(checkZipCode){
      postalCodeLabel.text('Postal Code *');
      postalCode.addClass('required');
      postalCode.prop('required',true);
    }else{
      postalCodeLabel.text('Postal Code');
      postalCode.removeClass('required');
      postalCode.prop('required',false);
    }
  }

  function getRenderedStatesorProvince(countryVal) {
    const stateTypeSelect = $(".facility-state");
    stateTypeSelect.html('');
    let defaultSelectText = "";
    if (countryVal == "1") {
      defaultSelectText = "Select State";
    } else {
      defaultSelectText = "Select Province";
    }
    let option = $('<option />');
    option.attr('value', "-1").text(defaultSelectText);
    option.attr('selected', 'selected');
    option.attr('disabled', 'disabled');
    stateTypeSelect.append(option);
    if (countryVal == "1") {
      $(usaStates).each(function () {
        let option = $('<option />');
        option.attr('value', this.cdmValue).text(this.cdmMeaning);
        stateTypeSelect.append(option);
      });
    }
    else if (countryVal == "2") {
      $(caProvinces).each(function () {
        let option = $('<option />');
        option.attr('value', this.cdmValue).text(this.cdmMeaning);
        stateTypeSelect.append(option);
      });
    }
    stateTypeSelect.addClass("select2 select");
    instantiateSelect2(stateTypeSelect);
  }

  //Render functions for options to be displayed in the select drop downs 

  function getRenderedShipToAddress(shipToAddress) {
    const rmsFacilityTypesHtml = '<option value="{%- shipToAddress.cadAddressId %}">{%- shipToAddress.cadAddressId %} - {%- shipToAddress.cadLocationName %}</option>';
    const response = _.map(shipToAddress, (shipToAddress) => {
      return render(rmsFacilityTypesHtml, {
        shipToAddress: shipToAddress
      });
    });

    return response.join("");
  }

  function getRenderedRmsFacility(retailerFacilityForRMS) {
    const retailerFacilityHtml = '<option value="{%- rmsFacilityType.cdmValue %}">{%- rmsFacilityType.cdmMeaning %}</option>';
    const response = _.map(retailerFacilityForRMS, (rmsFacilityType) => {
      return render(retailerFacilityHtml, {
        rmsFacilityType: rmsFacilityType
      });
    });

    return response.join("");
  }

  function getRenderedFedexAccounts(retailerFedexAccounts) {
    const retailerFacilityHtml = '<option value="{%- fedexAccounts.cmtId %}">{%- fedexAccounts.cmtAccountNo %}</option>';
    const response = _.map(retailerFedexAccounts, (fedexAccounts) => {
      return render(retailerFacilityHtml, {
        fedexAccounts: fedexAccounts
      });
    });

    return response.join("");
  }

  function getRenderedCasAccounts(casAccountNumbers) {
    const retailerFacilityHtml = '<option value="{%-  casAccounts.ccaId %}">{%- casAccounts.ccaCasAccountnNumber %}</option>';
    const response = _.map(casAccountNumbers, (casAccounts) => {
      return render(retailerFacilityHtml, {
        casAccounts: casAccounts
      });
    });

    return response.join("");
  }

  function getRenderedCountries(countries) {
    const optionHtml = '<option value="{%- country.conId %}">{%- country.conName %}</option>';
    const response = _.map(countries, (country) => {
      return render(optionHtml, {
        country: country
      });
    });

    return response.join("");
  }

  function getRenderedPhoneCodes(phoneCodes) {
    const phoneCodeOptionHtml = '<option value="{%- phoneCode.conPhoneCode %}">{%- phoneCode.conPhoneText %}</option>';
    let count = 0;
    const response = _.map(phoneCodes, (phoneCode) => {
      if (phoneCode.conPhoneCode === '+1' && count == 0) {
        phoneCode.conPhoneText = "United States of America/Canada +1";
        count++;
        return render(phoneCodeOptionHtml, {
          phoneCode: phoneCode
        });
      } else if (phoneCode.conPhoneCode !== '+1') {
        return render(phoneCodeOptionHtml, {
          phoneCode: phoneCode
        });
      }
    });
    return response.join("");
  }

  //Render functions for the Facility Type checkbox
  function getRenderedFacilityTypes(facilityTypes) {
    const facilityTypeHtml = require("./html/createOrganization/facilityType.html");
    const response = _.map(facilityTypes, (facility) => {
      return render(facilityTypeHtml, {
        facility: facility
      });
    });

    return response.join("");
  }

  //Render functions for the Inbound classification Types
  function getRenderedInboundTypes(inboundClassificationTypes) {
   
    const inboundClassificationHtml = require("./html/createOrganization/inboundClassification.html");
    const response = _.map(inboundClassificationTypes, (inboundClassificationItem) => {
      return render(inboundClassificationHtml, {
        inboundClassificationItem: inboundClassificationItem
      });
    });

    return response.join("");
  }

  //Validate the Form 
  function validateForm(formElement) {
    let validator, validationOpts; 
    validationOpts = {
      debug: true,
      errorPlacement: function (error, element) {
        let appendClosest = $(element).data('error-placement-append-closest');
        if (appendClosest) {
          $(element).closest(appendClosest).append(error);
        } else {
          error.insertAfter(element);
        }
      }
    }
    validator = formElement.validate(validationOpts);
    validator.settings.ignore = ":disabled,:hidden";

    if (formElement.valid()&& !formElement.find('.dup-facName').is(':visible') && !formElement.find('.dup-facId').is(':visible')) {
      return true;
    } else {
      return false;
    }
  }

  //Validate the Address section 
  function validateAddressModal() {
    const addressSectionMap = {
      addFacilityCountrySelect: '#facility-country',
      facilityAddress1: '#facility-address1',
      facilityAddress2: '#facility-address2',
      facilityCity: '#facility-city',
      facilityZipCode: '#facility-zip',
      facilityStateDropDown: '#facility-state',
      facilityStateText: '#facility-stateText'
    }
    setElementsFromScope(elsPage, addressSectionMap, orgFacilityForm);
    let state = '';
    let isValidCountry = false;
    let countryValue='';
    $(countries).each(function() {
        if(this.conId.toString() === elsPage.addFacilityCountrySelect.val().toString()) {
          countryValue = this.conCode;
          return false;
        } 
      });
    $(validationReqdCountries).each(function() {
        if(this.cdmValue.toString() === countryValue.toString()) {
          isValidCountry = true;
          return false;
        } 
      });

    if (isValidCountry) {
      state = elsPage.facilityStateDropDown.val();
      $.ajax({
        url: addressValidationUrl,
        type: "POST",
        data: {
          [`${portletNamespace}cadAddress1`]: elsPage.facilityAddress1.val(),
          [`${portletNamespace}cadAddress2`]: elsPage.facilityAddress2.val(),
          [`${portletNamespace}cadCity`]: elsPage.facilityCity.val(),
          [`${portletNamespace}cadState`]: state,
          [`${portletNamespace}cadZipcode`]: elsPage.facilityZipCode.val(),
          [`${portletNamespace}cadCountry`]: countryValue
        },
        beforeSend: function () {
          $.blockUI({ message: 'Validating Address, Please Wait..' });
        },
        complete: function () {
          $.unblockUI();
        },
        success: function (data, textStatus, jqXHR) {
          addValResponse = $.parseJSON(data);
          if (addValResponse.result == true) {
            EditChecker.setPageClean();
            elsPage.addressReturned.css("display", "");
            elsPage.invalidAddress.css("display", "none");
            elsPage.invalidAddressText.css("display", "none");
            elsPage.returnedAddressRadio.prop('checked', false);
            elsPage.enteredAddressRadio.prop('checked', true);
            elsPage.returnedAddressRadio.show();
            checkSubmitAddressForm(addValResponse);
          } else {
            elsPage.addressReturned.css("display", "none");
            elsPage.invalidAddress.css("display", "");
            elsPage.invalidAddressText.css("display", "");
            elsPage.invalidAddressText.html('Unable to find a validated address');
            elsPage.returnedAddressRadio.hide();
            elsPage.returnedAddressRadio.prop('checked', false);
            elsPage.enteredAddressRadio.prop('checked', true);
            checkSubmitAddressForm(addValResponse);
          }
        }
      });
    } else {
      state = elsPage.facilityStateText.val();
      submitFacilityAddress(false);
    }
  }

  function checkSubmitAddressForm(addValResponse) {
    elsPage.enteredAddressText.html(addValResponse.enteredAdd);
    elsPage.returnedAddressText.html(addValResponse.returnedAdd);
    elsPage.returnedAddressRadio.prop('checked',true);
    addressEl.modal('show');
  }

  //If the user chooses to stay on the static form to modify the address 
  function modifyFacilityAddress() {
    addressEl.modal('hide');
  }

  //User chooses to submit the address whether the entered one or the returned one 
  function submitFacilityAddress(validationReqCountry=true) {
      const facilityObjMap = {
      facilityName: "#facility-name",
      facilityId: "#facility-id",
      contactName: "#contact-name",
      phoneCode: "#phone-code",
      phoneNumber: "#phone-number",
      emailId: "#email-id",
      state: "#facility-State",
      returnCenter: "#return",
      manualReturn: "#manual_return",
      partnerFacility: "#partner_facility",
      facilityType: "#rms-facility-type",
      fedExAccount: "#rms-fedex-account",
      rmsCharity: "#CHA",
      rmsDestroy: "#DES",
      rmsRecall: "#RCL",
      rmsRecycle: "#REC",
      rmsRefurbish: "#REF",
      rmsReturnable: "#RET",
      rmsReturnToStock: "#RTS",
      rmsSalvage: "#SAL",
      rmsMmc: "#MMC",
      returnAuthReq:"#return-auth-req",
	  stndRaLabel:"#stndRaLabel",
      stndNumber:"#stndNumber",
      casAccountNo:"#rms-cas-account",
      shipToAddress: "#ship-to-address"
    }
    setElementsFromScope(elsPage, facilityObjMap, orgFacilityForm);
    //On Submit address, create the CmrAddressObj and Store the values in it 
    let cmrAddressObj = {};
    let state = '';
    if (elsPage.addFacilityCountrySelect.val() == '1' || elsPage.addFacilityCountrySelect.val() == '2') {
      state = elsPage.facilityStateDropDown.val();
    } else {
      state = elsPage.facilityStateText.val();
    }

    //Facility Details
    if (!isHoneyComb) {
      cmrAddressObj.facilityType = elsPage.facilityType.val();  
      cmrAddressObj.fedExAccount = elsPage.fedExAccount.val();
      cmrAddressObj.cmrCasAccount = elsPage.casAccountNo.val();
	  //if condition updated by Dhans for Story B-1237968-Enable Return Authorization for Return Center flow in Facilities
      if (cmrAddressObj.facilityType === 'vendor' || cmrAddressObj.facilityType === 'return') {
        cmrAddressObj.returnAuthReq = elsPage.returnAuthReq.is(":checked");
        cmrAddressObj.cadStndNumber = elsPage.stndNumber.val();
      }
      if (cmrAddressObj.facilityType === 'inbound') {
        cmrAddressObj.shipToAddress = elsPage.shipToAddress.val();
      }
      cmrAddressObj.rmsCharity = elsPage.rmsCharity.is(":checked");
      cmrAddressObj.rmsDestroy = elsPage.rmsDestroy.is(":checked");
      cmrAddressObj.rmsRecall = elsPage.rmsRecall.is(":checked");
      cmrAddressObj.rmsRecycle = elsPage.rmsRecycle.is(":checked");
      cmrAddressObj.rmsRefurbish = elsPage.rmsRefurbish.is(":checked");
      cmrAddressObj.rmsReturnable = elsPage.rmsReturnable.is(":checked");
      cmrAddressObj.rmsReturnToStock = elsPage.rmsReturnToStock.is(":checked");
      cmrAddressObj.rmsSalvage = elsPage.rmsSalvage.is(":checked");   
      //MMC E-181400
      cmrAddressObj.rmsMmc = elsPage.rmsMmc.is(":checked");      
    } else {
      cmrAddressObj.returnCenter = elsPage.returnCenter.is(":checked");
      cmrAddressObj.manualReturn = elsPage.manualReturn.is(":checked");
      cmrAddressObj.partnerFacility = elsPage.partnerFacility.is(":checked");
    }

    //Set the common fields on the static form to the cmrAddressObj 
    cmrAddressObj.cadLocationName = elsPage.facilityName.val();
    cmrAddressObj.cadFacId = elsPage.facilityId.val();
    //edit Fix
    cmrAddressObj.cadId=cadEditId;
    cmrAddressObj.cadAddressId = elsPage.facilityId.val();
    cmrAddressObj.cadContactName = elsPage.contactName.val();
    cmrAddressObj.cadContactEmail = elsPage.emailId.val();
    cmrAddressObj.cadContactCountryPhoneCode = elsPage.phoneCode.val();
    cmrAddressObj.cadContactPhone = elsPage.phoneNumber.val();    
    cmrAddressObj.cadCommercialAddrFlag = addValResponse.returnedIsCommercial;
    cmrAddressObj.cadState = state;

    //If the user selects the Return address populate the Address validation response to the CMRObject 
    //Else If the user selects the Entered address populate the same values as mentioned in the Address section 
    if (elsPage.returnedAddressRadio.is(":checked") && validationReqCountry) {
      cmrAddressObj.cadCountry = elsPage.addFacilityCountrySelect.val();
      cmrAddressObj.cadState = addValResponse.returnedState
      cmrAddressObj.cadAddress1 = addValResponse.returnedAddress1;
      cmrAddressObj.cadAddress2 = addValResponse.returnedAddress2;
      cmrAddressObj.cadCity = addValResponse.returnedCity;
      cmrAddressObj.cadZipcode = addValResponse.returnedZip
      cmrAddressObj.cadUseStdAddress = '1';
    } 
    else{
      cmrAddressObj.cadCountry = elsPage.addFacilityCountrySelect.val();
      cmrAddressObj.cadAddress1 = elsPage.facilityAddress1.val();
      cmrAddressObj.cadAddress2 = elsPage.facilityAddress2.val();
      cmrAddressObj.cadCity = elsPage.facilityCity.val();
      cmrAddressObj.cadZipcode = elsPage.facilityZipCode.val();
      cmrAddressObj.cadUseStdAddress = '0';
    }
    if(cmrAddressObj.cadActive!==null){
      cmrAddressObj.cadActive=organizations.cadActive;
    }
    addressEl.modal('hide');    
    facilityArray.push(cmrAddressObj);
    saveFacility();
  }

  function generateOrganizationActiveCheckErrorModals(){  
    organizationActiveCheckErrorModal = $(render(sharedModalHtml,{
          title: 'Activate Facility Error',
          footerBtns: '<a href="#" class="base-btn purple-btn  cancel-deactivate-rule modal-auto-hide">Okay</a>',
          body: "<div class=q-pad-all-xl>This facility is inactive due to it's organization being in an inactive status. In order to activate this facility you must first reactivate it's organization.</div>",
          topCloseBtn: true,
          autoHideTop: true,
          modalDialogClass: "q-modal-dialog-800"      
        }));
        
       $('body').append(organizationActiveCheckErrorModal);
      }


  function populateEditForm(cmrAddressObj) {
    elsPage.orgName.val(cmrAddressObj.cadOrganizationName);
    cadEditId = cmrAddressObj.cadId;
    organizations.orgName = cmrAddressObj.cadOrganizationName;
    const orgNewFormHtml  = $(render(facilityWrapperTemplate,
      {
        masterForm: false,
        ...cmrAddressObj,
        facilityDetails: render(facilityDetailsHtml, {
          ...cmrAddressObj,
          rmsFacilityTypes:getRmsFacilityTypes(),
          cadAddressId: cmrAddressObj.cadAddressId,
          dupFacName:duplicateCadLocationNameMessage,
          dupFacId: duplicateAddressIdMessage
        }),
        facilityType:getHcmbFacilityTypesEdit(cmrAddressObj),
        inboundClassification:getRMSTypesEdit(cmrAddressObj),
        facilityAddress: render(facilityAddressHtml, {
          ...cmrAddressObj,
          countries: getRenderedCountries(countries),
        }),
        facilityContact: render(facilityContactHtml, {
          ...cmrAddressObj,
          phoneCodes: getRenderedPhoneCodes(phoneCodes)

        }),
        facilityName: cmrAddressObj.cadLocationName,
        sectionIsExpandable: true,
        isHoneyComb
      }
    ));
    elsPage.staticFacilityFormDiv.append(orgNewFormHtml);

    ///Trigger on the default values
    instantiateSelect2(orgNewFormHtml.find('.select2-select'));

    let phoneCodeIdSelected="";
    if(cmrAddressObj.cadContactCountryPhoneCode != null ){
      phoneCodeIdSelected=cmrAddressObj.cadContactCountryPhoneCode;
    }

    let stateCodeIdSelected="";
    if(cmrAddressObj.cadState != null ){
      stateCodeIdSelected=cmrAddressObj.cadState;
    }

    let countryCodeIdSelected="";
    if(cmrAddressObj.cadCountry != null ){
      countryCodeIdSelected=cmrAddressObj.cadCountry;
    }

    let rmsFedExAccountSelected="";
    if(cmrAddressObj.cadCmtId != null ){
      rmsFedExAccountSelected=cmrAddressObj.cadCmtId;
    }

    let casAccountSelected="";
    if(cmrAddressObj.cadCcaId != null){
      casAccountSelected = cmrAddressObj.cadCcaId;
    }

    let rmsShipToAddressSelected="";
    if(cmrAddressObj.cadShipAddressId != null ){
      rmsShipToAddressSelected=cmrAddressObj.cadShipAddressId;
    }


    //Handle the change events in the form 
    orgNewFormHtml.find(".facility-country").on("change", handleCountryChange);
    $('#rms-facility-type').on('change', showInboundClassification);
    orgNewFormHtml.find(".facility-country").val(countryCodeIdSelected).trigger('change');
    if(cmrAddressObj.cadCountry === "1" || cmrAddressObj.cadCountry ==="2"){
      orgNewFormHtml.find(".facility-state").val(stateCodeIdSelected).trigger('change');
    }else{
      orgNewFormHtml.find("#facility-stateText").val(stateCodeIdSelected);      
    }
    orgNewFormHtml.find(".facility-phone-code").val(phoneCodeIdSelected).trigger('change');
    orgNewFormHtml.find("#rms-fedex-account").val(rmsFedExAccountSelected).trigger('change');
    orgNewFormHtml.find("#rms-cas-account").val(casAccountSelected).trigger('change');
    
    if (!isHoneyComb) {
      const attrArray = cmrAddressObj.cmrAddressAttributes;
      let facType = "";
      for (let i = 0; i < attrArray.length; i++) {
        if (attrArray[i].caaValue === "VR") {
          facType="vendor";  
        }
        else if(attrArray[i].caaValue === "RC"){
          facType="return";
        }
        else if(attrArray[i].caaValue === "IS"){
          facType="inbound";
        }
      }
	  //if condition updated by Dhans for Story B-1237968-Enable Return Authorization for Return Center flow in Facilities
      if(facType === "vendor"){
        orgNewFormHtml.find(".rms-facility-type").val(facType).trigger('change');
        orgNewFormHtml.find('#inboundClassification').hide();
        let vrRequired="false";
        for(let i = 0; i < attrArray.length; i++){
          if(attrArray[i].caaKey === "vendor_ra_required"){
            vrRequired = attrArray[i].caaValue;
          }
        }
        if(vrRequired === "true"){
          orgNewFormHtml.find("#return-auth-req").prop('checked',true);
          for(let i = 0; i < attrArray.length; i++){
            if(attrArray[i].caaKey === "vendor_standing_ra"){
              orgNewFormHtml.find("#stndNumber").show();
              orgNewFormHtml.find("#stndNumber").val(attrArray[i].caaValue);
            }
          }
        }
      } else if(facType === "return"){
        orgNewFormHtml.find(".rms-facility-type").val(facType).trigger('change');
        orgNewFormHtml.find('#inboundClassification').show();
        let vrRequired="false";
        for(let i = 0; i < attrArray.length; i++){
          if(attrArray[i].caaKey === "vendor_ra_required"){
            vrRequired = attrArray[i].caaValue;
          }
        }
        if(vrRequired === "true"){
          orgNewFormHtml.find("#return-auth-req").prop('checked',true);
          for(let i = 0; i < attrArray.length; i++){
            if(attrArray[i].caaKey === "vendor_standing_ra"){
              orgNewFormHtml.find("#stndNumber").show();
              orgNewFormHtml.find("#stndNumber").val(attrArray[i].caaValue);
            }
          }
        }
      }else{
        orgNewFormHtml.find(".rms-facility-type").val(facType).trigger('change');
        orgNewFormHtml.find('#inboundClassification').show();
        
        if(facType === "inbound"){
          orgNewFormHtml.find("#ship-to-address").val(rmsShipToAddressSelected);
        }
      }
    }
  }

  function getRenderedFacilityTypesEdit(facilityTypes, cmrAddressAttributes) {
    const facilityTypeHtml = require("./html/createOrganization/facilityType.html");
    const response = _.map(facilityTypes, (facility) => {
      return render(facilityTypeHtml, {
        facility: facility,
        isChecked: getValuesForTypes(cmrAddressAttributes, facility)
      });
    });
    return response.join("");
  }

  function getValuesForTypes(cmrAddressAttributes, facility) {
    let checked = "";
    for (let i = 0; i < cmrAddressAttributes.length; i++) {
      if (facility.cdmMeaning === cmrAddressAttributes[i].caaKey ) {
        checked = "checked";
      }
    }
    return checked;
  }

  function getRenderedInboundTypesEdit(inboundClassificationTypes, cmrAddressAttributes) {
    const inboundClassificationHtml = require("./html/createOrganization/inboundClassification.html");
    const response = _.map(inboundClassificationTypes, (inboundClassificationItem) => {
      return render(inboundClassificationHtml, {
        inboundClassificationItem: inboundClassificationItem,
        isChecked: getValuesForInbound(cmrAddressAttributes, inboundClassificationItem)
      });
    });

    return response.join("");
  }

  function getValuesForInbound(cmrAddressAttributes, inbound) {
    let checked = "";
    for (let i = 0; i < cmrAddressAttributes.length; i++) {
      if (cmrAddressAttributes[i].caaValue == inbound.cdmValue) {
        checked = "checked";
      }
    }
    return checked;
  }

  init();
}



// WEBPACK FOOTER //
// ./src/pages/facilities/addOrgFacilityForm.js